export enum ModalDismissReasons {
  CUSTOMISE,
  BACKDROP_CLICK,
  ESC_KEY,
  YES,
  NO
}
